<template>
  <div class="cp-home-wrapper" v-if="!isCPLoading">
    <a v-if="session.step_static_data" :href="bannerLink" :target="bannerLinkTarget">
      <div class="cp-banner-container">
        <img alt="static-image" class="static-image d-none d-md-inline-block cp-banner" v-if="session.step_static_data.image"
             :src="session.step_static_data.image.file" @error="setAltImg($event)" />
        <img alt="static-image-mobile" class="static-image-mobile d-md-none d-sm-inline-block cp-banner" v-if="canShowMobileBanner"
             :src="mobileBannerImage" @error="setAltImg($event)" />
      </div>
    </a>
    <div class="cp-section">
      <OrderList :limit="1" :show-header="false" title="Recent Order" :is_active="false" :checkout="false" />
    </div>
    <div v-if="popularProducts.length" class="cp-section">
      <div class="cp-subheading d-flex align-items-center justify-content-between">
        <span class="flex-grow-1">Popular Products</span>
        <span v-if="hasMoreProduct" class="cp-showmore" @click.stop="toggleShowMore()">{{ showMore ? 'Show Less' : 'Show More' }}</span>
      </div>
      <div class="pp-wrapper">
        <b-card v-for="(product, index) in popularProducts" class="pp__item" v-bind:key="'pp-'+index" :class="{'show-all': showMore}">
          <div class="pp__item__image">
            <img :src="getImageUrl(product)" @error="setAltImg" :alt="product.name" />
          </div>
          <p class="pp__item__name">{{product.name}}</p>
          <p class="pp__item__price">{{product.price | currency}}</p>
          <div class="d-flex flex-column flex-md-row pp__item__btns">
            <b-button @click.stop="addToCart(product, true)" variant="primary" class="pp__item__add mb-2 mb-md-0 mr-0 mr-md-2 cp-buy-now">
              Buy Now
            </b-button>
            <b-button @click.stop="addToCart(product)" class="pp__item__add btn-outline-success">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M16 16C16.5304 16 17.0391 16.2107 17.4142 16.5858C17.7893 16.9609 18 17.4696 18 18C18 18.5304 17.7893 19.0391 17.4142 19.4142C17.0391 19.7893 16.5304 20 16 20C15.4696 20 14.9609 19.7893 14.5858 19.4142C14.2107 19.0391 14 18.5304 14 18C14 16.89 14.89 16 16 16ZM0 0H3.27L4.21 2H19C19.2652 2 19.5196 2.10536 19.7071 2.29289C19.8946 2.48043 20 2.73478 20 3C20 3.17 19.95 3.34 19.88 3.5L16.3 9.97C15.96 10.58 15.3 11 14.55 11H7.1L6.2 12.63L6.17 12.75C6.17 12.8163 6.19634 12.8799 6.24322 12.9268C6.29011 12.9737 6.3537 13 6.42 13H18V15H6C5.46957 15 4.96086 14.7893 4.58579 14.4142C4.21071 14.0391 4 13.5304 4 13C4 12.65 4.09 12.32 4.24 12.04L5.6 9.59L2 2H0V0ZM6 16C6.53043 16 7.03914 16.2107 7.41421 16.5858C7.78929 16.9609 8 17.4696 8 18C8 18.5304 7.78929 19.0391 7.41421 19.4142C7.03914 19.7893 6.53043 20 6 20C5.46957 20 4.96086 19.7893 4.58579 19.4142C4.21071 19.0391 4 18.5304 4 18C4 16.89 4.89 16 6 16ZM15 9L17.78 4H5.14L7.5 9H15Z" fill="currentColor"/>
              </svg>
              <span class="d-md-none">Add to Cart</span>
            </b-button>
          </div>
        </b-card>

        <OrderCheckout
          v-if="showCheckout"
          :items="selectedItems"
          :is-subscription="false"
          :skip-initial="true"
          @clear="toggleCheckout()">
        </OrderCheckout>
      </div>
    </div>
  </div>
  <ProcessingLoader v-else />
</template>

<script>
import axios from 'axios'
import {getCampaignProductImageUrl, getPlaceholderImageUrl, prepareCartItems} from '@/utils'
import {mapGetters, mapState} from 'vuex'

const OrderList = () => import('./../Order/OrderList')
const OrderCheckout = () => import('./../Order/OrderCheckout')
const ProcessingLoader = () => import('@/components/ProcessingLoader')

export default {
  name: 'CustomerPortalHome',
  components: {OrderList, OrderCheckout, ProcessingLoader},
  computed: {
    ...mapState(['session', 'cart', 'isCPLoading']),
    ...mapGetters(['checkoutDisabled']),
    bannerLink: function() {
      let staticData = this.session.step_static_data || {}
      if (staticData.link) {
        if (staticData.is_link_internal) {
          return '/step/' + staticData.link
        } else {
          return staticData.link
        }
      }
      return 'javascript:void(0);'
    },

    bannerLinkTarget: function() {
      let staticData = this.session.step_static_data || {}
      if (!staticData.link) {
        return ''
      }
      return staticData.is_link_internal ? '' : '_blank'
    },

    canShowMobileBanner: function() {
      let staticData = this.session.step_static_data || {}
      return staticData.image_mobile || staticData.image
    },

    mobileBannerImage: function() {
      let staticData = this.session.step_static_data || {}
      return staticData.image_mobile ? staticData.image_mobile.file : staticData.image.file
    }
  },
  data: function() {
    return {
      recentOrders: [],
      popularProducts: [],
      showCheckout: false,
      selectedItems: [],
      showMore: false,
      hasMoreProduct: false
    }
  },
  methods: {
    toggleCheckout: function(items) {
      this.showCheckout = !this.showCheckout
      this.selectedItems = items || []
    },
    getImageUrl: function(product) {
      return getCampaignProductImageUrl(product, 'original')
    },
    setAltImg: function() {
      event.target.src = getPlaceholderImageUrl('small')
    },
    postAddToCartProcess: function(checkout) {
      if (checkout) {
        this.$router.push({name: 'session-jump', params: {step: 'checkout'}})
      } else {
        this.$store.commit('set_cart_state', true)
        setTimeout(() => {
          this.$store.commit('set_cart_state', false)
          this.$store.commit('ready')
        }, 5000)
      }
    },
    addToCart: function(products, checkout) {
      const cart = this.cart || []
      if (!(products instanceof Array)) {
        products = [products]
      }
      const items = prepareCartItems(cart, {products, checkout})
      if (items.length > 0) {
        this.$store.commit('busy')
        this.$store.dispatch('add_cart', items)
          .then(() => {
            this.postAddToCartProcess(checkout)
            this.$store.commit('ready')
          })
          .catch(err => {
            let errorMessage = ''
            if (err.response.status === 400) {
              errorMessage = err.response.data['items']
            }
            this.$store.commit('error', errorMessage || err)
            this.$store.commit('ready')
          })
      } else {
        this.postAddToCartProcess(checkout)
      }
    },
    toggleShowMore: function() {
      this.showMore = !this.showMore
    },
    showMoreProducts: function() {
      if (window) {
        if (window.innerWidth < 992) {
          this.hasMoreProduct = this.popularProducts.length > 2
        } else {
          this.hasMoreProduct = this.popularProducts.length > 3
        }
      }
    }
  },
  created() {
    axios.get('/campaign_products/popular/')
      .then((result) => {
        this.popularProducts = result.data || []
        this.showMoreProducts()
      })
      .catch((error) => this.$store.commit('critical_error', error))

    window.addEventListener('resize', this.showMoreProducts)
  }
}
</script>

<style scoped>

</style>
